import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['link', 'activeLink', 'indicator']

  connect() {
    this.locked = false
    this.resetIndicatorTimeout = null
    this.renderIndicator()
  }

  disconnect() {
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.remove()
    }
  }

  lock() {
    this.locked = true
  }

  renderIndicator() {
    if (!this.hasActiveLinkTarget) return

    const indicator = document.createElement('div')
    indicator.dataset.navbarTabsTarget = 'indicator'
    indicator.style.width = `${this.activeLinkTarget.offsetWidth}px`
    indicator.style.height = `3px`
    indicator.style.left = `${this.activeLinkTarget.offsetLeft}px`
    indicator.style.top = `${this.activeLinkTarget.offsetTop + this.activeLinkTarget.offsetHeight - 10}px`
    indicator.classList.add('bg-[--active-navbar-item]', 'absolute', 'rounded-full', 'transition-all', 'duration-300')
    this.element.append(indicator)
    const scrollOffset = this.activeLinkTarget.getBoundingClientRect().right - this.element.getBoundingClientRect().right
    if (scrollOffset > 0) {
      this.element.scrollBy(scrollOffset, 0)
    }
  }

  moveIndicator(event) {
    if (!this.hasActiveLinkTarget || !this.hasIndicatorTarget) return

    const scrollEvent = event.type === 'scroll'
    const element = event.type === 'mouseenter' ? event.target : this.activeLinkTarget

    if (event.type === 'mouseenter') {
      this.resetIndicatorTimeout && clearTimeout(this.resetIndicatorTimeout)
      this._moveIndicator(element)
    } else {
      if (scrollEvent) {
        this.indicatorTarget.classList.remove('duration-300', 'transition-all')
        this._moveIndicator(element)
        this.indicatorTarget.classList.add('duration-300', 'transition-all')
      } else {
        this.resetIndicatorTimeout = setTimeout(() => {
          this._moveIndicator(element)
        }, 300)
      }
    }
  }

  _moveIndicator(element) {
    if (!this.hasIndicatorTarget) return
    if (this.locked) return

    this.indicatorTarget.style.width = `${element.offsetWidth}px`
    this.indicatorTarget.style.left = `${element.offsetLeft}px`
  }
}
